import { Popover, Space, Tooltip } from 'antd';
import React from 'react';
import './csvDetailCard.scss';
import {
    CheckSquareOutlined,
    CloseSquareOutlined,
    DownloadOutlined,
    FileDoneOutlined,
    Loading3QuartersOutlined,
    LoadingOutlined,
} from '@ant-design/icons';

const CsvDetailsCard = props => {
    const downloadCsvData = (orderId, csvId) => {
        const data = [orderId, csvId];
        props.downloadFileCsv(data);
    };

    const handleResultant = () => {
        console.log('sh 111');
    };

    return (
        <div>
            <div className="csv_card_section">
                <div>
                    <h5 className="">CSV File Name</h5>
                    <Tooltip title={props.csvFileName}>
                        <span className="card_subtitle  text-overflow">{props.csvFileName}</span>
                    </Tooltip>
                </div>
                <div>
                    <h5 className="">Upload Date</h5>
                    <span className="card_subtitle">
                        {new Date(props.uploadDateAndTime).toLocaleDateString('en-US', {
                            day: 'numeric',
                            month: 'short',
                            year: 'numeric',
                        })}
                    </span>
                    <br />
                </div>
                <div>
                    <h5 className="">Uploaded by</h5>
                    <span className="card_subtitle">{props.userName}</span>
                </div>
                <div>
                    <h5 className="">Validation Status</h5>
                    <div
                        style={{
                            display: 'flex',
                            justifyContent: 'center',
                            gap: '13px',
                        }}
                    >
                        <span className="card_subtitle">
                            {props.validationStatus ? (
                                <CheckSquareOutlined
                                    style={{
                                        fontSize: '20px',
                                        color: 'green',
                                    }}
                                />
                            ) : props.inProgressCsv.includes(props.csvId) || props.parseStatus === 'pending' ? (
                                <Popover content={props.parseStatus}>
                                    {/* <Loading3QuartersOutlined
                    style={{
                      fontSize: "20px",
                      color: "blue",
                    }}
                  /> */}
                                    <LoadingOutlined
                                        style={{
                                            fontSize: 25,
                                            // color:'rgb(31 158 255)'
                                        }}
                                        spin
                                    />
                                </Popover>
                            ) : (
                                <Popover content={props.failedResponse}>
                                    <CloseSquareOutlined
                                        style={{
                                            fontSize: '20px',
                                            color: 'red',
                                        }}
                                    />
                                </Popover>
                            )}
                        </span>
                    </div>
                </div>
                <Space style={{ height: '100%' }} split>
                    <div className="card-data-spacing-center">
                        <h5 className="">Original File</h5>

                        <DownloadOutlined
                            style={{
                                fontSize: '20px',
                                cursor: 'pointer',
                            }}
                            onClick={() => downloadCsvData(props?.orderId, props.csvId)}
                        />
                    </div>

                    {props.csvType == 'outbound' && (
                        <div className="card-data-spacing-center">
                            <h5 className="">Resultant</h5>
                            <FileDoneOutlined
                                style={{
                                    fontSize: '20px',
                                    cursor: 'pointer',
                                    marginLeft: '5px',
                                }}
                                onClick={() => props.downloadResultant(props?.orderId, props.csvId)}
                            />
                        </div>
                    )}
                </Space>

                {/* <div>
          <h5 className="">Attach to Order</h5>
          <span className="card_subtitle">{<Switch defaultChecked/>}</span>
        </div> */}
            </div>
        </div>
    );
};

export default CsvDetailsCard;
